"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.badField = exports.zone = exports.zoneParent = exports.testFields = void 0;
exports.testFields = [
    {
        type: "Feature",
        geometry: {
            type: "MultiPolygon",
            coordinates: [
                [
                    [
                        [-87.18319, 38.4401028],
                        [-87.1804998, 38.4401268],
                        [-87.1804723, 38.4401287],
                        [-87.1800949, 38.4401796],
                        [-87.1800606, 38.4401829],
                        [-87.1800261, 38.4401835],
                        [-87.1792814, 38.4401678],
                        [-87.1791606, 38.4401929],
                        [-87.1790928, 38.4402403],
                        [-87.1790781, 38.4402529],
                        [-87.1790568, 38.4402872],
                        [-87.1790488, 38.4403079],
                        [-87.179023, 38.4404607],
                        [-87.1790214, 38.4404801],
                        [-87.1790356, 38.4417435],
                        [-87.1790521, 38.4418648],
                        [-87.1791394, 38.4420772],
                        [-87.1791494, 38.4421193],
                        [-87.1791535, 38.442167],
                        [-87.1791505, 38.4421996],
                        [-87.1791035, 38.4424812],
                        [-87.1791022, 38.4425066],
                        [-87.1791274, 38.4428673],
                        [-87.1791277, 38.4428903],
                        [-87.1791257, 38.4429132],
                        [-87.1790766, 38.4432539],
                        [-87.1790692, 38.4434244],
                        [-87.1790981, 38.4435561],
                        [-87.179168, 38.4436298],
                        [-87.1793428, 38.4436742],
                        [-87.1793695, 38.4436773],
                        [-87.1804724, 38.4436715],
                        [-87.1815528, 38.4437015],
                        [-87.1823913, 38.4436738],
                        [-87.1824221, 38.4436707],
                        [-87.1825845, 38.4436417],
                        [-87.1827154, 38.443564],
                        [-87.1827883, 38.443442],
                        [-87.1828173, 38.4430308],
                        [-87.1828207, 38.4430048],
                        [-87.1828271, 38.4429796],
                        [-87.1828362, 38.4429552],
                        [-87.1828481, 38.4429319],
                        [-87.1828626, 38.4429097],
                        [-87.1828795, 38.4428888],
                        [-87.1828986, 38.4428691],
                        [-87.1829198, 38.442851],
                        [-87.1829431, 38.4428344],
                        [-87.1829681, 38.4428194],
                        [-87.1829949, 38.4428063],
                        [-87.1830232, 38.4427951],
                        [-87.1830529, 38.4427859],
                        [-87.1830839, 38.4427788],
                        [-87.183116, 38.4427739],
                        [-87.183149, 38.4427714],
                        [-87.1833688, 38.442763],
                        [-87.1833783, 38.4427622],
                        [-87.1833869, 38.4427591],
                        [-87.1834716, 38.4427229],
                        [-87.1835341, 38.4426389],
                        [-87.183546, 38.4420077],
                        [-87.1835322, 38.4418627],
                        [-87.1835313, 38.4418335],
                        [-87.1835476, 38.4413669],
                        [-87.1835344, 38.4403304],
                        [-87.1835317, 38.440308],
                        [-87.183514, 38.4402316],
                        [-87.1834259, 38.4401376],
                        [-87.1833004, 38.4401047],
                        [-87.18319, 38.4401028],
                    ],
                ],
            ],
        },
        properties: {
            id: "00b2d5ad-2df6-49da-8504-49ea71bbe98e",
        },
    },
    {
        type: "Feature",
        geometry: {
            type: "MultiPolygon",
            coordinates: [
                [
                    [
                        [-91.2131271, 39.9061975],
                        [-91.2110671, 39.9043539],
                        [-91.2133846, 39.9034979],
                        [-91.2131271, 39.9061975],
                    ],
                ],
            ],
        },
        properties: {
            id: "02290b6f-c48e-49a7-9dd5-8206d5152be4",
        },
    },
    {
        type: "Feature",
        geometry: {
            type: "MultiPolygon",
            coordinates: [
                [
                    [
                        [-90.1772474, 39.996559],
                        [-90.1771038, 40.0033613],
                        [-90.1770981, 40.0036282],
                        [-90.180214, 40.0036932],
                        [-90.1832907, 40.0037566],
                        [-90.1894028, 40.0038953],
                        [-90.1897767, 40.0038169],
                        [-90.1903374, 40.0037261],
                        [-90.1907178, 40.0037249],
                        [-90.190668, 40.0029506],
                        [-90.1907643, 40.0025755],
                        [-90.1907843, 40.0024191],
                        [-90.1907525, 40.0021987],
                        [-90.1907016, 40.0021138],
                        [-90.1905968, 40.0020171],
                        [-90.1898736, 40.00122],
                        [-90.1885464, 40.0006183],
                        [-90.1881951, 40.0004357],
                        [-90.1875872, 40.0001348],
                        [-90.1867663, 39.9998166],
                        [-90.1863183, 39.9992465],
                        [-90.1864689, 39.9966716],
                        [-90.18341, 39.9966515],
                        [-90.18352, 39.9968625],
                        [-90.1835946, 39.9970882],
                        [-90.1836876, 39.9972494],
                        [-90.1838406, 39.9975408],
                        [-90.1839606, 39.9975959],
                        [-90.184151, 39.9975901],
                        [-90.1842981, 39.9976459],
                        [-90.1844823, 39.9977235],
                        [-90.1846906, 39.997867],
                        [-90.185096, 39.9980623],
                        [-90.1854306, 39.9982146],
                        [-90.1855309, 39.9983862],
                        [-90.186278, 39.9993759],
                        [-90.186817, 40.0001411],
                        [-90.1871316, 40.0003029],
                        [-90.1875781, 40.0004625],
                        [-90.1878439, 40.0006048],
                        [-90.188128, 40.0006326],
                        [-90.1883932, 40.0007339],
                        [-90.1890235, 40.0009886],
                        [-90.1893245, 40.0012116],
                        [-90.1899519, 40.0015334],
                        [-90.1902906, 40.0018864],
                        [-90.190533, 40.0022683],
                        [-90.1904498, 40.0036348],
                        [-90.1901275, 40.0036982],
                        [-90.1901066, 40.003702],
                        [-90.1894684, 40.0038186],
                        [-90.189354, 40.003854],
                        [-90.1890994, 40.0036994],
                        [-90.1890427, 40.0036294],
                        [-90.1889233, 40.0034009],
                        [-90.1888858, 40.0032284],
                        [-90.1889236, 40.0026687],
                        [-90.1888913, 40.0025523],
                        [-90.1871143, 40.0011721],
                        [-90.1858096, 40.0010968],
                        [-90.1855968, 40.0007487],
                        [-90.1852573, 40.0004166],
                        [-90.1847932, 39.9998882],
                        [-90.1844409, 39.9992903],
                        [-90.1835882, 39.9988065],
                        [-90.1829955, 39.9983319],
                        [-90.1825568, 39.9980423],
                        [-90.1823377, 39.9976261],
                        [-90.1821586, 39.9972785],
                        [-90.1821466, 39.9967892],
                        [-90.1821235, 39.9966181],
                        [-90.1794705, 39.9965855],
                        [-90.1772474, 39.996559],
                    ],
                    [
                        [-90.180879, 40.0022329],
                        [-90.1803175, 40.0014185],
                        [-90.1787892, 40.001324],
                        [-90.1787757, 40.000933],
                        [-90.1773043, 40.0008989],
                        [-90.1773076, 40.0000982],
                        [-90.1798324, 40.000194],
                        [-90.1798464, 40.000938],
                        [-90.1806446, 40.0010604],
                        [-90.1809512, 40.000839],
                        [-90.1813034, 40.0013166],
                        [-90.180879, 40.0022329],
                    ],
                    [
                        [-90.183978, 40.0034258],
                        [-90.1820841, 40.0027168],
                        [-90.1822455, 40.002017],
                        [-90.1825068, 40.0021152],
                        [-90.1825312, 40.0014838],
                        [-90.1819279, 40.0013565],
                        [-90.1810452, 40.0005701],
                        [-90.181271, 40.0002977],
                        [-90.1819084, 40.0007136],
                        [-90.1828005, 40.000776],
                        [-90.182756, 40.0021824],
                        [-90.1843208, 40.00282],
                        [-90.183978, 40.0034258],
                    ],
                    [
                        [-90.1801467, 39.997019],
                        [-90.1800299, 39.9971034],
                        [-90.1798818, 39.9971357],
                        [-90.1793483, 39.9971392],
                        [-90.1786048, 39.9971325],
                        [-90.1772972, 39.9971006],
                        [-90.177316, 39.9965909],
                        [-90.1774615, 39.9966201],
                        [-90.177539, 39.9966836],
                        [-90.1781856, 39.9966942],
                        [-90.1782735, 39.9966656],
                        [-90.1785473, 39.9966569],
                        [-90.1786228, 39.9966074],
                        [-90.1790157, 39.9966221],
                        [-90.1798885, 39.9966485],
                        [-90.1800873, 39.996679],
                        [-90.1801648, 39.9968159],
                        [-90.1801467, 39.997019],
                    ],
                    [
                        [-90.1772662, 39.9995132],
                        [-90.1772711, 39.9986523],
                        [-90.1774934, 39.9984371],
                        [-90.1778749, 39.9980821],
                        [-90.1786023, 39.9974541],
                        [-90.1786049, 39.9980127],
                        [-90.1785388, 39.9984944],
                        [-90.1772662, 39.9995132],
                    ],
                ],
            ],
        },
        properties: {
            id: "038f375f-459f-4b8f-8a46-4714e563303b",
        },
    },
    {
        type: "MultiPolygon",
        coordinates: [
            [
                [
                    [-98.3162923, 40.6139801],
                    [-98.3163651, 40.615761],
                    [-98.315546, 40.6157697],
                    [-98.3156418, 40.6156577],
                    [-98.3158775, 40.6153065],
                    [-98.3160636, 40.6149385],
                    [-98.316198, 40.6145577],
                    [-98.3162793, 40.6141684],
                    [-98.3162923, 40.6139801],
                ],
            ],
        ],
    },
];
exports.zoneParent = {
    type: "Feature",
    properties: {
        id: "038f375f-459f-4b8f-8a46-4714e563asdf",
    },
    geometry: {
        type: "MultiPolygon",
        coordinates: [
            [
                [
                    [-93.8227744, 41.567111],
                    [-93.8226595, 41.5673107],
                    [-93.8227381, 41.5678819],
                    [-93.8225891, 41.5683297],
                    [-93.8227332, 41.5684358],
                    [-93.8227252, 41.5687396],
                    [-93.8223575, 41.5688227],
                    [-93.8219105, 41.5692189],
                    [-93.8209973, 41.5694399],
                    [-93.8204657, 41.5697385],
                    [-93.819611, 41.5698786],
                    [-93.8196239, 41.5699589],
                    [-93.8193641, 41.5701126],
                    [-93.8192766, 41.5707207],
                    [-93.8199592, 41.570876],
                    [-93.8270227, 41.5702575],
                    [-93.8269863, 41.5685991],
                    [-93.8275036, 41.5685496],
                    [-93.8281756, 41.5685843],
                    [-93.8281783, 41.5683046],
                    [-93.8281798, 41.5666553],
                    [-93.823565, 41.5670444],
                    [-93.8227744, 41.567111],
                ],
            ],
        ],
    },
};
exports.zone = {
    type: "Feature",
    properties: {
        id: "038f375f-459f-4b8f-8a46-4714e56jkl;f",
    },
    geometry: {
        type: "Polygon",
        coordinates: [
            [
                [-91.62733912467957, 41.72567093674894],
                [-91.62751212716103, 41.725703967100884],
                [-91.62764891982079, 41.7257450047872],
                [-91.6277776658535, 41.72576101948698],
                [-91.62825778126717, 41.72579204795639],
                [-91.62838518619537, 41.72580606080862],
                [-91.62858501076698, 41.725853103933076],
                [-91.62868157029152, 41.725865114938046],
                [-91.62876337766647, 41.72586411402105],
                [-91.62882775068283, 41.725851102098716],
                [-91.62893235683441, 41.7257830396926],
                [-91.62896990776062, 41.72573399467882],
                [-91.62898868322372, 41.72566793398883],
                [-91.62898868322372, 41.72560887967816],
                [-91.62897258996964, 41.72556083545314],
                [-91.62893638014793, 41.72551779580439],
                [-91.6287311911583, 41.725341633220694],
                [-91.62870034575462, 41.725300595276735],
                [-91.62870168685913, 41.72524854711497],
                [-91.62874594330788, 41.72519950169317],
                [-91.62889882922173, 41.72513744416702],
                [-91.62895783782005, 41.72509740702159],
                [-91.62905439734459, 41.72493125260138],
                [-91.62914827466011, 41.724848175230164],
                [-91.62926226854324, 41.72477010242196],
                [-91.62931859493256, 41.72474608000033],
                [-91.62938833236694, 41.724742076262515],
                [-91.62946075201035, 41.724761094014866],
                [-91.62960156798363, 41.724838165901076],
                [-91.62973836064339, 41.72486819388365],
                [-91.63007900118828, 41.724899222784245],
                [-91.6305859386921, 41.72490923210381],
                [-91.63061946630478, 41.72497128985037],
                [-91.63065701723099, 41.72500732335314],
                [-91.63081794977188, 41.725132439525225],
                [-91.63093730807304, 41.72520750911153],
                [-91.6310003399849, 41.72526556286476],
                [-91.63103923201561, 41.72535264339632],
                [-91.63114115595818, 41.725676942268734],
                [-91.63119480013847, 41.72608531629808],
                [-91.63122698664665, 41.72615538020895],
                [-91.63131952285767, 41.72626447957512],
                [-91.63140669465065, 41.72631352418395],
                [-91.63153275847435, 41.72634255056744],
                [-91.6316306591034, 41.72635255966219],
                [-91.6317929327488, 41.72634054874831],
                [-91.63192301988602, 41.726291504160116],
                [-91.63199946284294, 41.726277491413754],
                [-91.63207992911339, 41.7263015132628],
                [-91.6321724653244, 41.72635055784335],
                [-91.63224756717682, 41.72637357875604],
                [-91.63224756717682, 41.72723135210015],
                [-91.63217380642891, 41.72726938612561],
                [-91.63207322359085, 41.72736046751615],
                [-91.6304437816143, 41.72735246036615],
                [-91.63025066256523, 41.727316428178625],
                [-91.63012593984604, 41.727271387915806],
                [-91.63005620241165, 41.727263380754664],
                [-91.62998512387276, 41.72727238881092],
                [-91.629848331213, 41.72735045857846],
                [-91.62731230258942, 41.72733844785117],
                [-91.62733912467957, 41.72567093674894],
            ],
        ],
    },
};
exports.badField = {
    type: "Feature",
    geometry: {
        type: "MultiPolygon",
        coordinates: [],
    },
    properties: {
        id: "00b2d5ad-2df6-49da-8504-49ea71bbe98g",
    },
};
